/** @format */

import { api } from 'utility';
import { getBusinessUrl } from 'URLs';

const source = api.cancelToken;
let cancelToken;

export function getBusiness() {
  if (cancelToken) {
    cancelToken.cancel('cancelToken');
  }

  cancelToken = source.source();

  return api
    .get(getBusinessUrl(), {
      cancelToken: cancelToken.token,
    })
    .then((res) => res.data);
}
